import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const UseInfoPassport = ({
  isEdit,
  userInfo,
  setUserInfo,
  validateStatus,
  setValidateStatus
}) => {
  const today = dayjs();
  const minDate = today.add(6, "month"); // 半年後
  const maxDate = today.add(10, "year"); // 10年後

  const passportNoHandler = (e) => {
    const input = e.target.value;
    const trimmed = input.trim().toUpperCase();
    const passportRegex = /^[A-Z]{2}[0-9]{7}$/;
    const isValid = passportRegex.test(trimmed);

    setValidateStatus((prev) => ({
      ...prev,
      passportNo: {
        valid: isValid,
        message: isValid ? "" : "パスポート番号の形式が正しくありません"
      }
    }));
    setUserInfo((prev) => ({ ...prev, passportNo: trimmed }));
  };

  const passportExpiryHandler = (e) => {
    const inputDate = dayjs(e);

    let val = { valid: true, message: "" };

    if (!e || !inputDate.isValid()) {
      val = {
        valid: false,
        message: "旅券有効期限の入力は必須です"
      };
    } else if (inputDate.isBefore(minDate) || inputDate.isAfter(maxDate)) {
      val = {
        valid: false,
        message: "有効期限は 半年以上十年以内で入力してください。"
      };
    }

    setValidateStatus((prev) => ({
      ...prev,
      passportExpiry: val
    }));

    setUserInfo((prev) => ({
      ...prev,
      passportExpiry: inputDate.format("YYYY/MM/DD")
    }));
  };

  return (
    <dl className="dl">
      <dt>
        旅券番号{isEdit && <span>※</span>}
      </dt>
      <dd>
        {isEdit ? (
          <div>
            <TextField
              value={userInfo.passportNo}
              onChange={passportNoHandler}
              error={!validateStatus.passportNo?.valid} // booleanに修正
              helperText={validateStatus.passportNo?.message} // メッセージはhelperTextへ
              InputProps={{
                sx: {
                  "& input": {
                    padding: "8px 16px"
                  }
                }
              }}
              sx={{ width: "100%" }}
            />
          </div>
        ) : (
          <div>{userInfo.passportNo}</div>
        )}
      </dd>

      <dt>
        旅券有効期限{isEdit && <span>※</span>}
      </dt>
      <dd>
        {isEdit ? (
          <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="YYYY/MM/DD"
                minDate={minDate}
                maxDate={maxDate}
                value={
                  userInfo.passportExpiry ? dayjs(userInfo.passportExpiry) : null
                }
                onChange={passportExpiryHandler}
                slotProps={{
                  textField: {
                    error: !validateStatus.passportExpiry?.valid,
                    helperText: validateStatus.passportExpiry?.message,
                    sx: { width: "100%" }
                  }
                }}
              />
            </LocalizationProvider>
          </div>
        ) : (
          <div>{userInfo.passportExpiry}</div>
        )}
      </dd>
    </dl>
  );
};

export default UseInfoPassport;
